import { Service, signal } from '@angular/core';

@Service()
export class AppUiService {
  showFooterBubble = signal(false);
  showFooterBubbleSignal = this.showFooterBubble.asReadonly();

  toggleFooterBubble() {
    this.showFooterBubble.update((u) => !u);
  }
}
